<div class="card">
    <p-table #dt [value]="listWareHouse" [rows]="20" [paginator]="true"
        [globalFilterFields]="['name','country.name','representative.name','status']" [(selection)]="selectedWareHouse"
        [rowHover]="true" dataKey="storeId" styleClass="p-datatable-responsive-demo"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true">
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between">
                <h5 class="p-m-0">Ordenes Por surtir</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Search..." />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="name">Zona <p-sortIcon field="zone"></p-sortIcon></th>
                <th pSortableColumn="begDate">Nombre<p-sortIcon field="begDate"></p-sortIcon></th>
                <th pSortableColumn="coordName">#Aprobado <p-sortIcon field="coordName"></p-sortIcon></th>
                <th pSortableColumn="secreName">#Ordenes Por Susrtir <p-sortIcon field="secreName"></p-sortIcon></th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-warehouse>
            <tr>
                <td>{{warehouse.mateName}}</td>
                <td>{{warehouse.address}}</td>
                <td>{{warehouse.shortName}}</td>
                <td>
                    <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                        (click)="editZone(zone)"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                In total there are {{listZonesCoord ? listZonesCoord.length : 0 }} warehouse.
            </div>
        </ng-template>
    </p-table>
</div>